import {
  Gap as SharedGap,
  GapHead as SharedGapHead,
  GapNote as SharedGapNote,
  GapPanel as SharedGapPanel,
  GapRow as SharedGapRow,
  type GapBlockProps,
  type GapProps,
} from '@dorixona/ui'
import { env } from '../config/env'

/* Пометки выключены — места, которые держатся только на них (плитка без
   значения, колонка без данных), прячутся целиком, а не стоят пустыми. */
document.documentElement.toggleAttribute('data-gaps-off', !env.showApiGaps)

/**
 * Пометки «нет в API» в админке — те же, что в `@dorixona/ui`, но за
 * выключателем `VITE_SHOW_API_GAPS`, как на витрине. Выключены — места без
 * данных просто не показываются; список открытых мест остаётся в
 * docs/open-questions.md и в тестах (там пометки включены).
 */
export function Gap(props: GapProps) {
  return env.showApiGaps ? <SharedGap {...props} /> : null
}

export function GapRow(props: GapProps) {
  return env.showApiGaps ? <SharedGapRow {...props} /> : null
}

export function GapPanel(props: GapBlockProps) {
  return env.showApiGaps ? <SharedGapPanel {...props} /> : null
}

export function GapNote(props: GapBlockProps) {
  return env.showApiGaps ? <SharedGapNote {...props} /> : null
}

/** Заголовок колонки без данных: выключено — остаётся просто заголовок. */
export function GapHead(props: GapBlockProps) {
  return env.showApiGaps ? <SharedGapHead {...props} /> : <>{props.children}</>
}
